import { Form, message, Table } from "antd";
import { useEffect, useState } from "react";
import { getTableColumn } from "../../extensions/helper";
import { serverFetch } from "../../server";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import ClientAbonPackageChange from "./client-abon-package-change";
import { isMobile } from "../../extensions/design";
import ClientItemAbonPackage from "./client-item-abon-package";

const ClientAbonItemPackets = ({ id, onAbonsUpdate, abon }) => {
  const [loading, setLoading] = useState(false);
  const [packageItems, setPackageItems] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    getUsageData();
  }, []);

  const getUsageData = () => {
    setLoading(true);
    serverFetch(`sale/ProductList/${id}`)
      .then((data) => {
        setPackageItems(data);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage || "Ошибка загрузки");
      });
  };
  const onEdit = () => { };

  const handleClose = (refresh) => {
    setSelectedId(null);
    refresh ? getUsageData() : setPackageItems([...packageItems.filter(i => i.id !== 0)]);
    refresh && onAbonsUpdate();
  };

  const onRowClick = record => setSelectedId(record.id === selectedId ? null : record.id);

  const packageColumns = [
    getTableColumn("productName", "Наименование", { type: "string" }, packageItems),
    getTableColumn("qty", "Количество", { type: "number", width: 25 }, packageItems),
    getTableColumn("qtyRest", "Остаток", { type: "number", width: 25 }, packageItems),
  ];

  const content = !isMobile ? [
  <> 
    <Form.Item style={{ marginTop: "8px" }}></Form.Item>
      <Table dataSource={packageItems} loading={loading} columns={packageColumns} rowKey="id" size="small" className="table-detail" pagination={false} 
      expandable={{
          expandedRowRender: record => <ClientAbonPackageChange pack={record} onAbonsUpdate={onAbonsUpdate} onClose={handleClose} />,
          expandedRowKeys: selectedId != null ? [selectedId] : [],
          onExpand: (expanded, record) => setSelectedId(expanded ? record.id : null),
          expandIcon: ({ expanded, onExpand, record }) => expanded ? <DownOutlined onClick={(e) => onExpand(record, e)} /> : <RightOutlined onClick={(e) => onExpand(record, e)} />,
          expandIconColumnIndex: packageColumns.length + 1,
          rowExpandable: () => true,
          className: "cl-abons-expandable",
        }}
        onRow={(record) => ({ onClick: () => onRowClick(record) })}
        rowSelection={{ type: 'radio', selectedRowKeys: selectedId != null ? [selectedId] : [], renderCell: (checked) => ( 
            <div className={checked ? "list-indicator" : ""} /> 
          ),
        }}
      /> 
  </>
  ] : [
    <Form>
      <div className="client-items" style={{ overflowY: "scroll", overflowX: "clip" }}>
      {packageItems.map((item) => {
        const isExpanded = selectedId == item.id;
          return (
            <div key={item.id}>
              <div onClick={() => setSelectedId(isExpanded ? null : [item.id])} style={{ cursor: "pointer" }}>
                <ClientItemAbonPackage item={{ ...item, docDate: item.docDate?.format("DD.MM.YYYY") }} expanded={isExpanded}
                 setExpanded={setSelectedId} onClose={handleClose} onAbonsUpdate={onAbonsUpdate}/>
              </div>
            </div>
          );
        })}
      </div>
    </Form>
  ]

  return (
    <>
      {content}
    </>
  );
};

export default ClientAbonItemPackets;
